import { create } from "zustand";
import { persist } from "zustand/middleware";

const DISMISSED_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

interface PwaState {
  updateAvailable: boolean;
  installDismissedAt: number | null;
  notifDismissedAt: number | null;

  // Actions
  setUpdateAvailable: (available: boolean) => void;
  dismissInstall: () => void;
  dismissNotif: () => void;
  resetDismissals: () => void;

  // Helpers (used in components)
  isInstallDismissed: () => boolean;
  isNotifDismissed: () => boolean;
}

export const usePwaStore = create<PwaState>()(
  persist(
    (set, get) => ({
      updateAvailable: false,
      installDismissedAt: null,
      notifDismissedAt: null,

      setUpdateAvailable: (available) => set({ updateAvailable: available }),

      dismissInstall: () => set({ installDismissedAt: Date.now() }),

      dismissNotif: () => set({ notifDismissedAt: Date.now() }),

      resetDismissals: () =>
        set({ installDismissedAt: null, notifDismissedAt: null }),

      isInstallDismissed: () => {
        const dismissedAt = get().installDismissedAt;
        if (!dismissedAt) return false;
        const elapsed = Date.now() - dismissedAt;
        return elapsed < DISMISSED_TTL_MS;
      },

      isNotifDismissed: () => {
        const dismissedAt = get().notifDismissedAt;
        if (!dismissedAt) return false;
        const elapsed = Date.now() - dismissedAt;
        return elapsed < DISMISSED_TTL_MS;
      },
    }),
    {
      name: "thecoach-pwa-storage",
      partialize: (state) => ({
        installDismissedAt: state.installDismissedAt,
        notifDismissedAt: state.notifDismissedAt,
      }),
    },
  ),
);
